import React from 'react'
import Subheader from '../Subheader'
import Navbar from '../Navbar'
import ArrayContact from './ArrayContact'

function AllContact() {
  return (
    <div>
<Subheader/>
<Navbar/>
<ArrayContact/>

    </div>
  )
}

export default AllContact